var React = require('react');

function PinFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 21.0469C16.5176 21.0469 21.0879 16.4863 21.0879 10.959C21.0879 5.44141 16.5176 0.871094 10.9902 0.871094C5.47266 0.871094 0.912109 5.44141 0.912109 10.959C0.912109 16.4863 5.48242 21.0469 11 21.0469ZM8.59766 7.31641C8.59766 5.98828 9.67188 4.91406 11 4.91406C12.3281 4.91406 13.4121 5.98828 13.4121 7.31641C13.4121 8.38086 12.7285 9.26953 11.7812 9.58203V14.5137C11.7812 15.9102 11.4883 17.2188 11 17.2188C10.5117 17.2188 10.209 15.8809 10.209 14.5137V9.57227C9.28125 9.25977 8.59766 8.37109 8.59766 7.31641ZM9.64258 6.68164C9.64258 7.0918 10.0039 7.45312 10.4043 7.45312C10.8242 7.45312 11.166 7.0918 11.1758 6.68164C11.1758 6.27148 10.8242 5.91016 10.4043 5.91016C10.0039 5.91016 9.64258 6.27148 9.64258 6.68164Z","fill":"currentColor"}));
}

PinFilled.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = PinFilled;

PinFilled.default = PinFilled;
